const Main = () => {
  return (
    <main>
      <div className="main-content">
        <h1>Our Articles </h1>
        <article className="text-container">
          <h1>
            Should Web Developers Learn <span className="theme-text">AI ?</span>
          </h1>
          <p>
            The unprecedented growth of Artificial Intelligence (AI) has made it
            necessary for web development students and professionals to learn
            AI. The field is expected to affect almost 75% of customer
            communications in the future as it has enabled websites to have an
            efficient user interface to allow seamless customer interactions.
            <br /> <br />
            Since every web development company aims to maximize customer
            interaction, it’s only natural that the majority of the enterprises
            would soon adopt artificial intelligence for web development.
            Whether it’s an eCommerce website, a healthcare website, or an
            educational platform, chatbots have already minimized the need for
            human agents. In the near future, this involvement of AI is only
            predicted to grow exponentially, transforming the way customers
            interact with businesses.
          </p>
          <img
            src="https://indatalabs.com/wp-content/uploads/2021/08/should-web-developers-learn-ai.jpg"
            alt="should-web-developers-learn-ai"
          />
          <p>
            Since more and more customers prefer to engage online, businesses
            are integrating AI in their web development processes to offer an
            optimized customer experience. Therefore, web development businesses
            and enterprises are always in search of web developers who are well
            versed with AI and machine learning. They look for personnel who can
            easily integrate AI tools into website design and development. So it
            has become vital for web developers to learn AI, in order to excel
            in their careers.
          </p>
        </article>
        <article className="text-container">
          <h1>
            Will <span className="theme-text">AI</span> Take Over Web
            Development?
          </h1>
          <p>
            Web development and AI have been working interdependently for a
            while now. But to think that AI would take over web development, the
            idea seems quite far-fetched. Although the tools mentioned above can
            aid in the website development and design process, they can never
            truly replace the web development industry.
            <br />
            <br />
            AI tools have major shortcomings that keep them from independently
            designing and developing websites. It only services as a catalyst
            for the web development industry to save time and physical labor
            when developing websites. Because these tools can never measure up
            to the capabilities that a human has. They can only empower them.{" "}
            <br />
            <br />
            Therefore, instead of seeing AI as a threat that might replace web
            development, businesses should view AI as an empowering tool that
            can aid in everyday tasks that require time and effort.
          </p>
        </article>
        <article className="text-container">
          <h1>
            Will Backend Developers Be Replaced By{" "}
            <span className="theme-text">AI?</span>
          </h1>
          <p>
            A backend developer deals with the critical technical aspects of a
            website that keep it running smoothly for the user. Their tasks
            involve writing codes, maintaining database records, processing
            payments, and taking care of the back-end operations.
            <br />
            <br />
            Their tasks are critical, safe, repeatable, and prescribable.
            Therefore, assigning these crucial tasks to AI models would be
            highly risky. Because if a problem occurs or the website isn’t
            running as it should, it would be a back-end developer who re-codes
            the entire system manually.
            <br />
            <br />
            Therefore, the idea that backend developers would be replaced by AI
            is far-fetched. AI cannot replace 100% of their jobs. It can only do
            a small percentage of their tasks that involve monotonous work like
            coding. You will always need back-end developers for the majority of
            their tasks.
          </p>
        </article>
        <article className="text-container">
          <h1>
            Will <span className="theme-text">AI</span> Take Over Frontend
            Developer?
          </h1>
          <p>
            Although there are many website builders like Wix operational today,
            these AI tools can never replace how a talented frontend developer
            does their work. While these AI models can churn out beautiful and
            functional websites with the help of auto-generated code, they can
            never make additions and changes that are envisioned by a human.
            Therefore AI can never replace frontend developers, and there are
            many reasons why.
          </p>
          <img
            src="https://indatalabs.com/wp-content/uploads/2021/08/customer-behavior-analysis.jpg"
            alt="customer-behavior-analysis"
          />
          <p>
            Here’s a list of reasons why AI tools can never replace human
            developers :
          </p>
          <ul>
            <li>
              AI tools can never develop websites that can outgrow human
              comprehension related to optimized coding.
            </li>
            <li>
              AI models cannot produce perfect UI and UX websites that are free
              of bugs and glitches.
            </li>
            <li>
              They cannot produce images with complex customization and details.
            </li>
            <li>
              They cannot consistently produce websites with unique designs as
              the websites produced by AI tools are repetitive.
            </li>
            <li>They cannot give results without needing human assistance.</li>
          </ul>
        </article>
        <article className="text-container">
            <h1 className="theme-text">conclusion</h1>
          <p>
            Although web development and AI have been working co-dependently,
            there’s no reason for website developers and designers to feel a
            threat from artificial intelligence. AI can never replace the ideas
            of the human mind. It can only perform repetitive and monotonous
            tasks.
            <br /> <br />
            However, it’s crucial for website designers and developers to learn
            about artificial intelligence in order to truly utilize what it has
            to offer. Because in the near future, AI would be a bigger part of
            web development, considering how fast it’s growing. Therefore, being
            well versed in the field has now become essential for aspiring web
            developers.
          </p>
        </article>
      </div>
    </main>
  );
};

export default Main;
